export default {
  oops: 'Oops!',
  validOrigin: 'Vennligst velg en gyldig avreiseplassering',
  validDestination: 'Vennligst velg en gyldig destinasjon',
  validOutboundDate: 'Vennligst velg en gyldig avreisedato',
  validReturnDate: 'Vennligst velg et gyldig returdato',
  validChildAges: 'Vennligst velg alder av alle barn',
  oneChild: 'Det er kun tillatt med 1 barn (fra 0 til 2 år) pr. voksen',
}
